import { useEffect } from "react";
import { useSearchParams } from "react-router";

import { useConfirmSignUp } from "@/hooks/use-auth-client";

import { QUERY_PARAMS } from "@/routes/_constants/query-params";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";

export const useVerifyInvitationCompany = () => {
	const [searchParams] = useSearchParams();

	// const navigate = useNavigate();

	const { confirmSignUp } = useConfirmSignUp();

	const verifyCode = searchParams.get(QUERY_PARAMS.AUTH.INVITATION_VERIFY.VERIFY_CODE);
	const email = searchParams.get(QUERY_PARAMS.AUTH.INVITATION_VERIFY.USERNAME);
	const companyID = searchParams.get(QUERY_PARAMS.AUTH.INVITATION_VERIFY.COMPANY_ID);

	useEffect(() => {
		const callback = async () => {
			if (!verifyCode && !email && !companyID) {
				notifyUserEventInfo({
					title: "無効なURLです",
					description: "カスタマーサポートへお問い合わせください",
				});

				// navigate(PATHS.AUTH.SIGN_IN);
			} else {
				const clientMetaData = {
					companyID: companyID!,
				};
				await confirmSignUp(email!, verifyCode!, clientMetaData);
			}
		};

		callback();
	}, [email, verifyCode, companyID, confirmSignUp]);
};
